module.exports = __webpack_public_path__ + "static/job_posting.b3a900e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/index/assets/job_posting.jpg
// module id = 370
// module chunks = 35783957827783